export default __webpack_public_path__ + "static/media/evolution.6ce6cd0e.png";